// src/api/upload.js
import request from './index';

export function uploadImage(file) {
  return request.post('officialFile/upload', file, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}
